module.exports = __webpack_public_path__ + "media/ok.537e0ca3.mp3";